var map = {
	"./CUPOM.png": "9952",
	"./ELEICOES.png": "24fc",
	"./GTA.png": "66f8",
	"./GTF4.png": "7d67",
	"./GTF5.png": "9eaf",
	"./GTM.png": "6cf0",
	"./REAL.png": "fd40",
	"./TOP.png": "97ac",
	"./logo.svg": "9b19",
	"./printTest": "7402",
	"./printTest.js": "7402"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";